import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  createAppSetting,
  getAppSetting,
  editAppSetting,
  publishAppSetting,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { UserLang } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import { NecStore } from "../../store/necStore";

const AppSetting = (props) => {
  const initState = {
    actionBarStyle: "",
    androidMinVersion: "",
    iOSMinVersion: "",
    androidTvMinVersion: "",
    appleTvMinVersion: "",
    fireTvMinVersion: "",
    rokuMinVersion: "",
    SamsungMinVersion: "",
    LGMinVersion: "",
    loadingSpinner: "",
    landscapeOrientation: false,
    Casting: false,
    pip: false,
    subtitles: false,
    playinSmallWindow: false,
    imageBorder: true,
  };

  const [colorSchema, setColor] = useState(initState);
  const [colorCount, setColorCount] = useState("");
  const [colorStatus, setColorStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const lan = UserLang.useState((s) => s.lan);
  const role = NecStore.useState((s) => s.setting);

  const menuPic = [
    {
      value: "Hour Glass",
      label: "Hour Glass",
    },
    {
      value: "Circular",
      label: "Circular",
    },
    {
      value: "Grid Line",
      label: "Grid Line",
    },
    {
      value: "Ellipsis",
      label: "Ellipsis",
    },
    {
      value: "Grid",
      label: "Grid",
    },
    {
      value: "Ripple",
      label: "Ripple",
    },
  ];

  const stylePic = [
    {
      value: "Dark",
      label: "Dark",
    },
    {
      value: "Light",
      label: "Light",
    },
  ];
  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);
  const [allStyle, setStyle] = useState(stylePic);
  const handleChange = (evt) => {
    const value = evt.target.value;
    setColor({
      ...colorSchema,
      [evt.target.name]: value,
    });
  };

  const onChangeItemed = (value, evt) => {
    setColor({
      ...colorSchema,
      [evt.name]: value.value,
    });
  };
  const updateVisiblity = (event) => {
    setColor({
      ...colorSchema,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getAppSetting().then(
        (result) => {
          setColor(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setColorCount(obj.message);
          setColorStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    colorDetail();
  }, []);

  const colorSave = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (colorStatus === 404 || colorCount === "No Web Setting Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createAppSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editAppSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      /* eslint-disable no-unused-vars */
      const result = await publishAppSetting().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    App Setting Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"landscapeOrientation"}
                              id={"landscapeOrientation"}
                              defaultChecked={colorSchema.landscapeOrientation}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"cookiePolicy"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Landscape Orientation&nbsp;
                              {/* {
            !(lan==="rtl")&&
            <ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"Casting"}
                              id={"Casting"}
                              defaultChecked={colorSchema.Casting}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"Casting"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Casting&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable mirror casting for the video player in the mobile platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"subtitles"}
                              id={"subtitles"}
                              defaultChecked={colorSchema.subtitles}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"subtitles"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Subtitles&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable Subtitles for the video player in the mobile platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"pip"}
                              id={"pip"}
                              defaultChecked={colorSchema.pip}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"pip"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Picture in Picture&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable PIP for the video player in the mobile platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* {(lan==="rtl")&&
    <div className="col-sm-6"> */}
                      {/* <div className="form-group">
   <div className="custom-control custom-switch">
     <input type="checkbox" className="custom-control-input" name={"playinSmallWindow"} id={"playinSmallWindow"} defaultChecked={colorSchema.playinSmallWindow} onClick={(event) => updateVisiblity(event)}/>
     <label className={lan==="rtl"?"float-right custom-control-label not-bold":"float-left custom-control-label not-bold"} htmlFor={"playinSmallWindow"} onClick={ e => e.stopPropagation() }>Play in Small Window</label>
     </div>
     </div> */}

                      {/* </div>}    */}

                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"imageBorder"}
                              id={"imageBorder"}
                              defaultChecked={colorSchema.imageBorder}
                              onClick={(event) => updateVisiblity(event)}
                            />
                            <label
                              className="custom-control-label not-bold"
                              htmlFor={"imageBorder"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* {(lan==="rtl")&&<ToolTip 
                            info={"Publish date of the Article"}
                            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                              Image & Thumbnail Border&nbsp;
                              {
                                // !(lan==="rtl")&&
                                <ToolTip
                                  info={
                                    "Enable for border effect to the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              }
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-sm-12">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={
                                    "Select default loading animation for the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Loading Spinner&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={
                                    "Select default loading animation for the platform"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                            <Select
                              name="loadingSpinner"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allIcon}
                              onChange={(value, event) =>
                                onChangeItemed(value, event)
                              }
                            ></Select>

                            <div
                              className="row"
                              style={{
                                marginTop: "100px",
                                backgroundColor: "#f2f2f2",
                                marginLeft: "5px",
                              }}
                            >
                              <div
                                className="col-md-6"
                                style={{ marginTop: "20px", marginLeft: "2px" }}
                              >
                                <span>{colorSchema.loadingSpinner}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-sm-12">
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              {lan === "rtl" && (
                                <ToolTip
                                  info={
                                    "Define status bar colour Schema for mobile devices"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                              &nbsp;Action Bar Style/Status Bar Style&nbsp;
                              {!(lan === "rtl") && (
                                <ToolTip
                                  info={
                                    "Define status bar colour Schema for mobile devices"
                                  }
                                  place={lan === "rtl" ? "left" : "right"}
                                />
                              )}
                            </label>
                            <Select
                              name="actionBarStyle"
                              className={
                                lan === "rtl"
                                  ? "form-control inside-select float-right"
                                  : "form-control inside-select float-left"
                              }
                              options={allStyle}
                              onChange={(value, event) =>
                                onChangeItemed(value, event)
                              }
                            ></Select>

                            <div
                              className="row"
                              style={{
                                marginTop: "100px",
                                backgroundColor: "#f2f2f2",
                                marginLeft: "5px",
                              }}
                            >
                              <div
                                className="col-md-6"
                                style={{ marginTop: "20px", marginLeft: "2px" }}
                              >
                                <span>{colorSchema.actionBarStyle}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publish}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default AppSetting;
